import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './app/app';
import { AppContainer } from '@schamburg-web/components';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <StrictMode>
    <AppContainer>
      <App></App>
    </AppContainer>
  </StrictMode>
);
